// src/utils/routeWarmup.js
// English: Centralized route chunk warmup helpers.
// Keep imports here so App/Navbar/root-slug page stay smaller and cleaner.

let commonRoutesWarmed = false;

const safeWarm = (loader) => {
  try {
    return loader();
  } catch {
    return Promise.resolve(null);
  }
};

export function warmCommonRouteChunks() {
  if (commonRoutesWarmed) return;
  commonRoutesWarmed = true;

  Promise.allSettled([
    safeWarm(() => import("../pages/Home")),
    safeWarm(() => import("../pages/RootSlugPage")),
    safeWarm(() => import("../pages/TopicView")),
    safeWarm(() => import("../pages/Profile")),
    safeWarm(() => import("../pages/UserProfile")),
    safeWarm(() => import("../pages/AddTopic")),
  ]).catch(() => {
    // English: Silent background warmup only.
  });
}

export function warmProfileRoute({ isAdminOrMod = false } = {}) {
  const jobs = [safeWarm(() => import("../pages/Profile"))];

  if (isAdminOrMod) {
    jobs.push(safeWarm(() => import("../pages/AdminProfile")));
  } else {
    jobs.push(safeWarm(() => import("../pages/UserProfile")));
  }

  Promise.allSettled(jobs).catch(() => {
    // English: Silent background warmup only.
  });
}

export function warmTopicRoute() {
  Promise.allSettled([
    safeWarm(() => import("../pages/TopicView")),
    safeWarm(() => import("../pages/TopicEdit")),
    safeWarm(() => import("../pages/SuggestTopic")),
  ]).catch(() => {
    // English: Silent background warmup only.
  });
}

export function warmAddTopicRoute() {
  safeWarm(() => import("../pages/AddTopic")).catch(() => {
    // English: Silent background warmup only.
  });
}